export const getStepValue = (decimalPlaces) => {
    if (decimalPlaces && decimalPlaces > 0) {
        return 1 / Math.pow(10, decimalPlaces);
    }
    return 'any';
};
